
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/verified-addresses",
      function () {
        return require("private-next-pages/account/verified-addresses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/verified-addresses"])
      });
    }
  